import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import ACCW from './ACCW';

ReactDOM.render(<ACCW />, document.getElementById('root-cw'));